// extracted by mini-css-extract-plugin
module.exports = {"root":"_0Q7ejtHJ","titleLabel":"d3m9HkEN","flexRow":"YdWDzRIW","targetsContainer":"gpKmS3xo"};